    import React from "react";
    import tw from "twin.macro";
    import styled from "styled-components";
    import { css } from "styled-components/macro"; //eslint-disable-line
    import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
    import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
    import TeamIllustrationSrc from "images/team-illustration-2.svg";
    import {ReactComponent as SvgDotPattern } from "images/dot-pattern.svg"

    const Container = tw.div`relative`;
    const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24 items-center`;
    const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
    const ImageColumn = tw(Column)`md:w-6/12 flex-shrink-0 relative`;
    const ImageColumn6040 = tw(Column)`md:w-4/12 flex-shrink-0 relative right-0`;
    const TextColumn = styled(Column)(props => [
    tw`md:w-6/12 mt-16 md:mt-0`,
    props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
    ]);

    const Image = styled.img(props => [
    props.imageRounded && tw`rounded`,
    props.imageBorder && tw`border`,
    props.imageShadow && tw`shadow`,
    ]);

    const DecoratorBlob = styled(SvgDotPattern)(props => [
    tw`w-20 h-20 absolute right-0 bottom-0 transform translate-x-1/2 translate-y-1/2 fill-current text-primary-500 -z-10`,
    ])

    const TextContent = tw.div`lg:py-8 text-center md:text-left`;

    const TextContentRight = tw.div`lg:py-2 text-center md:text-center`;

    const Subheading = tw(SubheadingBase)`text-center md:text-justify text-justify`;
    const Heading = tw(
    SectionHeading
    )`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
    const Description = tw.p`mt-4 text-center md:text-justify text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;

    const PrimaryButton = styled(PrimaryButtonBase)(props => [
        tw`mt-8 md:mt-8 text-sm inline-block mx-auto md:mx-0`,
        props.buttonRounded && tw`rounded-full`
    ]);


    export default ({
        subheading = undefined,
        heading = undefined,
        description = "description",
        descriptionRight = undefined,
        imageSrc = TeamIllustrationSrc,
        imageRounded = true,
        imageBorder = false,
        imageShadow = false,
        imageCss = null,
        imageDecoratorBlob = false,
        imageDecoratorBlobCss = null,
        textOnLeft = true,
        buttonLink = undefined,
        columns60x40 = false,
        buttonTitle = "",
        content = "",
    }) => {
    // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.

        const mountImages = () => {
            return imageSrc.map((e) => {
                return (
                    <>
                        <Image
                            css={imageCss}
                            src={e}
                            imageBorder={imageBorder}
                            imageShadow={imageShadow}
                            imageRounded={imageRounded}
                        />
                        {imageDecoratorBlob && <DecoratorBlob css={imageDecoratorBlobCss} />}
                    </>
                )
            })
        }

        const mountDescriptions = () => {
            return description.map((e) => {
                return (
                    <>
                        <br />
                        <Description>{description}</Description>
                    </>
                )
            })
        }

        const mountDescriptionsRight = () => {
            return descriptionRight.map((e) => {
                return (
                    <>
                        <br />
                        <Description>{e}</Description>
                    </>
                )
            })
        }

    return (
        <Container>
            <TwoColumn>
                {
                    (descriptionRight !== undefined) ? (
                        <div style={{ width: "50%" }}>
                            <img src={imageSrc} css={imageCss} style={{ maxWidth: "100%" }} alt="imagem compras de alertas para sensores" />
                            {mountDescriptionsRight()}
                        </div>
                    ) : (columns60x40) ? (
                        <ImageColumn6040>
                            {mountImages()}
                        </ImageColumn6040>
                    ) : (
                        <ImageColumn>
                            {mountImages()}
                        </ImageColumn>
                    )
                }
                <TextColumn textOnLeft={textOnLeft}>
                    <TextContent>
                        {(subheading !== undefined) && <Subheading>{subheading}</Subheading>}
                        {(heading !== undefined) && <Heading>{heading}</Heading>}
                        {mountDescriptions()}
                    </TextContent>
                    {content}
                    {buttonTitle &&
                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                        <PrimaryButton
                            buttonRounded={true}
                            as="a"
                            href={buttonLink}
                            target="_blank"
                        >
                            {buttonTitle}
                        </PrimaryButton>
                        </div>
                    }
                </TextColumn>
            </TwoColumn>
        </Container>
    );
    };
